import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "searchForm" ]

  connect() {
  }

  exportXLS(event) {
    Turbolinks.visit($(event.target).data("url") + "?" + $(this.searchFormTarget).serialize())
    $(event.target).blur()
  }
}
